// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,500;1,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
#root > * {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-size: 14px;
  font-family: 'Poppins';
}

a {
  /*text-decoration: underline;*/
  cursor: pointer;
}

#searchForm > .ant-row > .ant-row.ant-form-item {
  width: 100%;
  text-align: right;
  padding-right: 12px;
}
.ant-col {
  /*flex: 1;*/
  max-width: 100%;
  width: 100%;
}
.ant-btn:first-child {
  /*margin-right: 10px;*/
}
.layout-page-sider {
  overflow-y: auto;
}
.app-loading-wrapper.ant-spin-spinning {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(256, 256, 256, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  height: 64px;
  width: 200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}
.layout-page-header {
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9;
  box-shadow: 0 4px 10px #2f2f2f;
}
.layout-page-header-light {
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9;
  box-shadow: 0 4px 10px #dddddd;
}
.layout-page-header-main {
  padding: 0 15px;
  flex: 1 1;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.layout-page .actions {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.layout-page .actions > * {
  margin-left: 30px;
  height: 100%;
  display: flex;
  align-items: center;
}
.sidebar-trigger {
  width: 20px !important;
}

.layout-page-content {
  flex: auto;
  overflow: auto;
  padding: 6px;
  box-sizing: border-box;
  min-height: calc(100vh - 64px); /* Header balandligi 64px */
}
.MainContent {
  min-height: calc(100% - 40px);
  overflow: auto;
}
.ant-menu .ant-menu-item {
  /*white-space: unset !important;*/
}
#pageTabs-actions {
  margin-right: 10px;
}
.mainPage {
  padding: 16px 6px 6px 6px;
  flex: auto;
  overflow: auto;
  box-sizing: border-box;
}
.driver-filter-search {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.page-filter-search {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
/*.ant-tabs-card >.ant-tabs-nav .ant-tabs-tab{*/
/*border: 1px solid rgba(5, 5, 5, 0.06);*/
/*}*/
.editable-cell-value-wrap {
  padding: 4px 11px;
  border: 1px solid transparent;
  border-radius: 2px;
}
.editable-cell-value-wrap:hover {
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
}
/*input:-webkit-autofill {*/
/*    -webkit-box-shadow: 0 0 0 1000px white inset !important; !* Change 'white' to your desired background color *!*/
/*    -webkit-text-fill-color: inherit !important;*/
/*}*/

.config_tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  /*justify-content: space-between;*/
}

.custom-search-input .ant-input-search-button {
  padding: 8px;
}
@media (max-width: 991px) {
  .page-filter-search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .driver-filter-search {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .page-filter-search {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .driver-filter-search {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .page-filter-search {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}

.custom-select .ant-select-selection-overflow {
  max-height: 200px;
  overflow-y: auto;
}

.blue-badge .ant-badge-count {
  background-color: #1876ff;
}
@media (max-width: 768px) {
  .responsive-range-picker-popup {
    max-width: 100vw !important;
  }

  .responsive-range-picker-popup .ant-picker-panel-container {
    width: auto !important;
    max-width: calc(100vw - 16px) !important;
  }

  /* 2 calendarni yonma-yon emas ustma-ust qilamiz */
  .responsive-range-picker-popup .ant-picker-panels {
    display: flex !important;
    flex-direction: column !important;
  }

  .responsive-range-picker-popup .ant-picker-panel {
    width: 100% !important;
  }

  /* header elementlari siqilmasin */
  .responsive-range-picker-popup .ant-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,SAAO;EACP,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,8BAA8B,EAAE,2BAA2B;AAC7D;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,+CAA+C;AAC/C,yCAAyC;AACzC,IAAI;AACJ;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,2BAA2B;AAC3B,qHAAqH;AACrH,mDAAmD;AACnD,IAAI;;AAEJ;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;AACA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA,kDAAkD;EAClD;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,500;1,600&display=swap');\n\nhtml,\nbody,\n#root,\n#root > * {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  font-size: 14px;\n  font-family: 'Poppins';\n}\n\na {\n  /*text-decoration: underline;*/\n  cursor: pointer;\n}\n\n#searchForm > .ant-row > .ant-row.ant-form-item {\n  width: 100%;\n  text-align: right;\n  padding-right: 12px;\n}\n.ant-col {\n  /*flex: 1;*/\n  max-width: 100%;\n  width: 100%;\n}\n.ant-btn:first-child {\n  /*margin-right: 10px;*/\n}\n.layout-page-sider {\n  overflow-y: auto;\n}\n.app-loading-wrapper.ant-spin-spinning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n  background-color: rgba(256, 256, 256, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo {\n  height: 64px;\n  width: 200px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9;\n}\n.layout-page-header {\n  padding: 0 !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 9;\n  box-shadow: 0 4px 10px #2f2f2f;\n}\n.layout-page-header-light {\n  padding: 0 !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 9;\n  box-shadow: 0 4px 10px #dddddd;\n}\n.layout-page-header-main {\n  padding: 0 15px;\n  flex: 1;\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n}\n.layout-page .actions {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.layout-page .actions > * {\n  margin-left: 30px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.sidebar-trigger {\n  width: 20px !important;\n}\n\n.layout-page-content {\n  flex: auto;\n  overflow: auto;\n  padding: 6px;\n  box-sizing: border-box;\n  min-height: calc(100vh - 64px); /* Header balandligi 64px */\n}\n.MainContent {\n  min-height: calc(100% - 40px);\n  overflow: auto;\n}\n.ant-menu .ant-menu-item {\n  /*white-space: unset !important;*/\n}\n#pageTabs-actions {\n  margin-right: 10px;\n}\n.mainPage {\n  padding: 16px 6px 6px 6px;\n  flex: auto;\n  overflow: auto;\n  box-sizing: border-box;\n}\n.driver-filter-search {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n.page-filter-search {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n/*.ant-tabs-card >.ant-tabs-nav .ant-tabs-tab{*/\n/*border: 1px solid rgba(5, 5, 5, 0.06);*/\n/*}*/\n.editable-cell-value-wrap {\n  padding: 4px 11px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n}\n.editable-cell-value-wrap:hover {\n  padding: 4px 11px;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  cursor: pointer;\n}\n/*input:-webkit-autofill {*/\n/*    -webkit-box-shadow: 0 0 0 1000px white inset !important; !* Change 'white' to your desired background color *!*/\n/*    -webkit-text-fill-color: inherit !important;*/\n/*}*/\n\n.config_tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 50px;\n  /*justify-content: space-between;*/\n}\n\n.custom-search-input .ant-input-search-button {\n  padding: 8px;\n}\n@media (max-width: 991px) {\n  .page-filter-search {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .driver-filter-search {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .page-filter-search {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 600px) {\n  .driver-filter-search {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .page-filter-search {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.custom-select .ant-select-selection-overflow {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.blue-badge .ant-badge-count {\n  background-color: #1876ff;\n}\n@media (max-width: 768px) {\n  .responsive-range-picker-popup {\n    max-width: 100vw !important;\n  }\n\n  .responsive-range-picker-popup .ant-picker-panel-container {\n    width: auto !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  /* 2 calendarni yonma-yon emas ustma-ust qilamiz */\n  .responsive-range-picker-popup .ant-picker-panels {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  .responsive-range-picker-popup .ant-picker-panel {\n    width: 100% !important;\n  }\n\n  /* header elementlari siqilmasin */\n  .responsive-range-picker-popup .ant-picker-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
